export const emailValidator = (email = '', validationMessage) => (
  null
)



// WEBPACK FOOTER //
// ./src/utils/validators.js